export default __webpack_public_path__ + "static/media/invest-with-us-banner.ab3695ce.jpg";